// extracted by mini-css-extract-plugin
export var chevron = "_gn-4";
export var chevronExpanded = "_gn-5";
export var row = "_gn-0";
export var rowBody = "_gn-6";
export var rowDescription = "_gn-7";
export var rowHeader = "_gn-1";
export var rowTitle = "_gn-2";
export var rowTitleComplete = "_gn-3";